import { defineAsyncComponent } from 'vue';
import { RouteRecordRaw } from 'vue-router';
import { contractsOverviewGuards } from './guards/contracts-overview.guard';

const contractRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'ContractsOverview',
      component: defineAsyncComponent(() => import('@/modules/contract/pages/ContractsOverview.vue')),
      meta: { skipTitleGuard: true },
      beforeEnter: contractsOverviewGuards(),
   },
   {
      path: 'create',
      name: 'CreateContract',
      redirect: '/contracts#create-employment',
      meta: { searchable: true, titleKey: 'actions.add', aliasKeys: ['contracts.contract'] },
   },
];

export default contractRoutes;
